import * as React from "react";
import { Icon } from "baseui/icon";
import { IconProps } from "baseui/icon";

const Calendar: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9219 1.5625H16.6667V0.567708C16.6667 0.28125 16.4323 0.046875 16.1458 0.046875C15.8594 0.046875 15.625 0.28125 15.625 0.567708V1.5625H10.5208V0.567708C10.5208 0.28125 10.2865 0.046875 10 0.046875C9.71354 0.046875 9.47917 0.28125 9.47917 0.567708V1.5625H4.32292V0.567708C4.32292 0.28125 4.08854 0.046875 3.80208 0.046875C3.51562 0.046875 3.28125 0.28125 3.28125 0.567708V1.5625H2.07812C0.932292 1.5625 0 2.52604 0 3.67188V15.7812C0 16.9323 0.927083 17.8646 2.07812 17.8646H17.9167C19.0677 17.8646 19.9948 16.9323 19.9948 15.7865V3.67188C20 2.52604 19.0677 1.5625 17.9219 1.5625ZM18.9583 15.7812C18.9583 16.3542 18.5 16.8177 17.9271 16.8229H17.9219H2.07812C1.50521 16.8229 1.04167 16.3594 1.04167 15.7865V15.7812V3.67188C1.04167 3.09375 1.50521 2.60417 2.07812 2.60417H3.28125V3.35938C3.28125 3.64583 3.51562 3.88021 3.80208 3.88021C4.08854 3.88021 4.32292 3.64583 4.32292 3.35938V2.60417H9.47917V3.35938C9.47917 3.64583 9.71354 3.88021 10 3.88021C10.2865 3.88021 10.5208 3.64583 10.5208 3.35938V2.60417H15.625V3.35938C15.625 3.64583 15.8594 3.88021 16.1458 3.88021C16.4323 3.88021 16.6667 3.64583 16.6667 3.35938V2.60417H17.9219C18.5 2.60417 18.9583 3.09896 18.9583 3.67188V15.7812Z"
        fill="black"
      />
      <path
        d="M8.63005 5.98959H7.71859C7.43213 5.98959 7.19775 6.22396 7.19775 6.51042C7.19775 6.79688 7.43213 7.03125 7.71859 7.03125H8.63005C8.9165 7.03125 9.15088 6.79688 9.15088 6.51042C9.15088 6.22396 8.9165 5.98959 8.63005 5.98959Z"
        fill="black"
      />
      <path
        d="M12.255 5.98959H11.3436C11.0571 5.98959 10.8228 6.22396 10.8228 6.51042C10.8228 6.79688 11.0571 7.03125 11.3436 7.03125H12.255C12.5415 7.03125 12.7759 6.79688 12.7759 6.51042C12.7759 6.22396 12.5467 5.98959 12.255 5.98959Z"
        fill="black"
      />
      <path
        d="M15.9113 5.98959H14.9998C14.7134 5.98959 14.479 6.22396 14.479 6.51042C14.479 6.79688 14.7134 7.03125 14.9998 7.03125H15.9113C16.1978 7.03125 16.4321 6.79688 16.4321 6.51042C16.4321 6.22396 16.1978 5.98959 15.9113 5.98959Z"
        fill="black"
      />
      <path
        d="M8.63005 9.58334H7.71859C7.43213 9.58334 7.19775 9.81771 7.19775 10.1042C7.19775 10.3906 7.43213 10.625 7.71859 10.625H8.63005C8.9165 10.625 9.15088 10.3906 9.15088 10.1042C9.15088 9.81771 8.9165 9.58334 8.63005 9.58334Z"
        fill="black"
      />
      <path
        d="M4.979 9.58334H4.06234C3.77588 9.58334 3.5415 9.81771 3.5415 10.1042C3.5415 10.3906 3.77588 10.625 4.06234 10.625H4.9738C5.26025 10.625 5.49463 10.3906 5.49463 10.1042C5.49463 9.81771 5.26546 9.58334 4.979 9.58334Z"
        fill="black"
      />
      <path
        d="M12.255 9.58334H11.3436C11.0571 9.58334 10.8228 9.81771 10.8228 10.1042C10.8228 10.3906 11.0571 10.625 11.3436 10.625H12.255C12.5415 10.625 12.7759 10.3906 12.7759 10.1042C12.7759 9.81771 12.5467 9.58334 12.255 9.58334Z"
        fill="black"
      />
      <path
        d="M15.9113 9.58334H14.9998C14.7134 9.58334 14.479 9.81771 14.479 10.1042C14.479 10.3906 14.7134 10.625 14.9998 10.625H15.9113C16.1978 10.625 16.4321 10.3906 16.4321 10.1042C16.4321 9.81771 16.1978 9.58334 15.9113 9.58334Z"
        fill="black"
      />
      <path
        d="M8.63005 13.125H7.71859C7.43213 13.125 7.19775 13.3594 7.19775 13.6458C7.19775 13.9323 7.43213 14.1667 7.71859 14.1667H8.63005C8.9165 14.1667 9.15088 13.9323 9.15088 13.6458C9.15088 13.3594 8.9165 13.125 8.63005 13.125Z"
        fill="black"
      />
      <path
        d="M4.979 13.125H4.06234C3.77588 13.125 3.5415 13.3594 3.5415 13.6458C3.5415 13.9323 3.77588 14.1667 4.06234 14.1667H4.9738C5.26025 14.1667 5.49463 13.9323 5.49463 13.6458C5.49463 13.3594 5.26546 13.125 4.979 13.125Z"
        fill="black"
      />
      <path
        d="M12.255 13.125H11.3436C11.0571 13.125 10.8228 13.3594 10.8228 13.6458C10.8228 13.9323 11.0571 14.1667 11.3436 14.1667H12.255C12.5415 14.1667 12.7759 13.9323 12.7759 13.6458C12.7759 13.3594 12.5467 13.125 12.255 13.125Z"
        fill="black"
      />
    </svg>
  </Icon>
);

export default Calendar;
